import { AttendanceEntry } from '../../attendance/types/attendance.types';
import { ClassLesson } from '../types/classLessons';

export const buildAttendanceEntriesFromLessons = (classId: string, lessons: ClassLesson[]): AttendanceEntry[] =>
  lessons
    .filter((lesson) => lesson.hasAttendance)
    .map((lesson) => ({
      id: lesson.classLessonId ?? `attendance-${classId}-${lesson.id}`,
      classId,
      lessonId: lesson.id,
      date: lesson.date,
      visitors: 0,
      magazines: 0,
      bibles: lesson.biblesCount ?? 0,
      offeringAmount: lesson.offeringAmount ?? 0,
      notes: lesson.notes ?? '',
      updatedAt: '',
      studentStatuses: (lesson.studentAttendances ?? []).map((attendance) => ({
        studentId: attendance.studentId,
        status: attendance.present ? 'present' : 'absent',
      })),
    }));

export const buildAttendanceRateByStudentId = (entries: AttendanceEntry[]) => {
  const totals = new Map<string, { present: number; total: number }>();

  entries.forEach((entry) => {
    entry.studentStatuses.forEach((studentStatus) => {
      const current = totals.get(studentStatus.studentId) ?? { present: 0, total: 0 };
      totals.set(studentStatus.studentId, {
        present: current.present + (studentStatus.status === 'present' ? 1 : 0),
        total: current.total + 1,
      });
    });
  });

  return Array.from(totals.entries()).reduce<Record<string, number>>((accumulator, [studentId, total]) => {
    accumulator[studentId] = total.total > 0 ? Math.round((total.present / total.total) * 100) : 0;
    return accumulator;
  }, {});
};

export const buildConsecutiveAbsencesByStudentId = (entries: AttendanceEntry[]) => {
  const sortedEntries = entries.slice().sort((left, right) => right.date.localeCompare(left.date));
  const streaks: Record<string, number> = {};

  sortedEntries.forEach((entry) => {
    entry.studentStatuses.forEach((studentStatus) => {
      if (streaks[studentStatus.studentId] === undefined) {
        streaks[studentStatus.studentId] = 0;
      }

      if (studentStatus.status === 'present' || streaks[studentStatus.studentId] < 0) {
        streaks[studentStatus.studentId] = -1;
        return;
      }

      streaks[studentStatus.studentId] += 1;
    });
  });

  return Object.entries(streaks).reduce<Record<string, number>>((accumulator, [studentId, streak]) => {
    accumulator[studentId] = Math.max(0, streak);
    return accumulator;
  }, {});
};
